var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized"},[_c('h1',[_vm._v("Acceso No Autorizado")]),_c('p',[_vm._v("No tienes permisos para acceder a esta sección.")]),_c('router-link',{attrs:{"to":"/dashboard"}},[_vm._v("Volver al inicio")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }